import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'

function isRecommendedWorkoutUtil (workout) {
  return !!getValueReduxUtil(workout, WORKOUT_KEY.RECOMMENDED_AT)
}

export default isRecommendedWorkoutUtil
